import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'components/Grid';
import * as webView from 'utils/webView';

import {
  Section,
  Title,
  List,
  Item,
  Download,
  SocialMedia,
  SocialMediaButton,
  StyledRow,
  CompanyInfo,
} from './styles';

const ExternalLink = ({ url, children }) => (
  <SocialMediaButton onClick={() => webView.openURL(url)}>
    {children}
  </SocialMediaButton>
);

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <Container>
        <Row>
          <Col xs={12} sm={6} lg={5} bottom={42}>
            <Title>{t('FOOTER.INTEREST.TITLE')}</Title>
            <List>
              <Item>{t('FOOTER.INTEREST.ITEMS.POLITICS_OF_DATA_PROCESSING')}</Item>
              <Item>{t('FOOTER.INTEREST.ITEMS.TERMS_AND_CONDITIONS')}</Item>
            </List>
          </Col>
          <Col xs={12} sm={6} lg={4} bottom={42}>
            <Title>{t('FOOTER.DOWNLOAD.TITLE')}</Title>
            <StyledRow>
              <ExternalLink url="https://play.google.com/store/apps/details?id=com.grability.rappi">
                <Download alt="PlayStore" src="/assets/images/footer/play-store.svg" />
              </ExternalLink>
              <ExternalLink url="https://apps.apple.com/br/app/rappi-delivery-de-tudo-e-mais/id984044296">
                <Download alt="AppleStore" src="/assets/images/footer/apple-store.svg" />
              </ExternalLink>
            </StyledRow>
          </Col>
          <Col xs={12} sm={6} lg={3} bottom={42}>
            <Title>{t('FOOTER.FOLLOW_US.TITLE')}</Title>
            <StyledRow>
              <ExternalLink url={t('FOOTER.FOLLOW_US.FACEBOOK')}>
                <SocialMedia name="facebook" />
              </ExternalLink>
              <ExternalLink url={t('FOOTER.FOLLOW_US.TWITTER')}>
                <SocialMedia name="twitter" />
              </ExternalLink>
              <ExternalLink url={t('FOOTER.FOLLOW_US.INSTAGRAM')}>
                <SocialMedia name="instagram" />
              </ExternalLink>
            </StyledRow>
          </Col>
        </Row>

        <CompanyInfo>{t('FOOTER.COMPANY_INFO')}</CompanyInfo>
      </Container>
    </Section>
  );
};

export default Footer;
